var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftteamsSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "msteamsSmall",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "microsoftteamsDark-Copy",
  transform: "translate(5.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.1818182,5.52272727 L10.2272727,5.52272727 L10.2272727,9.47727273 C10.2272727,10.7727273 11.3181818,11.8636364 12.6136364,11.8636364 C13.9090909,11.8636364 15,10.7727273 15,9.47727273 L15,6.34090909 C15,5.86363636 14.6590909,5.52272727 14.1818182,5.52272727 Z",
  id: "Path",
  fill: "#485BD5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.95454545,5.52272727 L3.95454545,10.2954545 C3.95454545,12.2727273 5.52272727,14.0454545 7.63636364,14.1818182 C9.95454545,14.3181818 11.8636364,12.6136364 11.8636364,10.4318182 L11.8636364,6.27272727 C11.8636364,5.86363636 11.5227273,5.52272727 11.0454545,5.52272727 L3.95454545,5.52272727 Z",
  id: "Path_1_",
  fill: "#6D81FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.90909091,0 C7.09090909,0 6.27272727,0.477272727 5.86363636,1.15909091 C5.45454545,1.84090909 5.45454545,2.79545455 5.86363636,3.54545455 C6.27272727,4.29545455 7.09090909,4.70454545 7.90909091,4.70454545 C8.72727273,4.70454545 9.54545455,4.22727273 9.95454545,3.54545455 C10.3636364,2.86363636 10.3636364,1.90909091 9.95454545,1.15909091 C9.54545455,0.409090909 8.72727273,0 7.90909091,0 L7.90909091,0 Z",
  id: "Path_2_",
  fill: "#5161CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6136364,0.818181818 C11.7272727,0.818181818 11.0454545,1.5 11.0454545,2.38636364 C11.0454545,3.27272727 11.7272727,3.95454545 12.6136364,3.95454545 C13.5,3.95454545 14.1818182,3.27272727 14.1818182,2.38636364 C14.1818182,1.5 13.5,0.818181818 12.6136364,0.818181818 Z",
  id: "Path_3_",
  fill: "#3440A0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.22727273,11.0454545 L0.681818182,11.0454545 C0.340909091,11.0454545 0,10.7727273 0,10.4318182 L0,4.56818182 C0,4.22727273 0.272727273,3.95454545 0.681818182,3.95454545 L7.22727273,3.95454545 C7.56818182,3.95454545 7.90909091,4.22727273 7.90909091,4.56818182 L7.90909091,10.5 C7.90909091,10.7727273 7.56818182,11.0454545 7.22727273,11.0454545 Z",
  id: "Path_4_",
  fill: "#2D399A"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path_5_",
  fill: "#FFFFFF",
  points: "5.52272727 5.52272727 2.38636364 5.52272727 2.38636364 6.20454545 3.54545455 6.20454545 3.54545455 9.47727273 4.36363636 9.47727273 4.36363636 6.20454545 5.52272727 6.20454545"
}))))));
export { SvgMicrosoftteamsSmall as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftteamsSmall.efa13e6a.svg";